module.exports = __webpack_public_path__ + "img/agustina-rabanal.b313455f.jpg";